module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.articleToEditKey) ? _c('div', [_c('div', {
    staticClass: "col-1"
  }, [_c('h3', [_vm._v("Articles")]), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, [_c('div', {
    staticStyle: {
      "width": "200px",
      "margin-right": "10px"
    }
  }, [_c('div', {
    staticClass: "input-label"
  }, [_vm._v("Filter by Status")]), _vm._v(" "), _c('div', {
    staticClass: "input-box down-caret"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStatus),
      expression: "filterStatus"
    }],
    attrs: {
      "label": "Status"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filterStatus = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "draft"
    }
  }, [_vm._v("draft")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "publish"
    }
  }, [_vm._v("published")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "preview"
    }
  }, [_vm._v("preview")])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "200px",
      "margin-right": "10px"
    }
  }, [_c('div', {
    staticClass: "input-label"
  }, [_vm._v("Filter by Category")]), _vm._v(" "), (_vm.showCategory) ? _c('div', {
    staticClass: "input-box down-caret"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterCategory),
      expression: "filterCategory"
    }],
    attrs: {
      "label": "Category"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filterCategory = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.updateSubcategories]
    }
  }, _vm._l((_vm.categories), function(item, key) {
    return _c('option', {
      key: key,
      domProps: {
        "value": item
      }
    }, [_vm._v(_vm._s(item))])
  }))]) : _vm._e(), _vm._v(" "), (_vm.subCategories) ? _c('div', {
    staticClass: "input-box down-caret"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterSubcategory),
      expression: "filterSubcategory"
    }],
    attrs: {
      "label": "Subcategory"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filterSubcategory = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.subCategories), function(subitem, subkey) {
    return _c('option', {
      key: subkey,
      domProps: {
        "value": subitem
      }
    }, [_vm._v(_vm._s(subitem))])
  }))]) : _vm._e()]), _vm._v(" "), (_vm.showTags) ? _c('div', {
    staticStyle: {
      "width": "200px",
      "margin-right": "10px"
    }
  }, [_c('div', {
    staticClass: "input-label"
  }, [_vm._v("Filter by Tag")]), _vm._v(" "), _c('div', {
    staticClass: "input-box tag-input-container",
    staticStyle: {
      "height": "auto"
    }
  }, [_c('tag-input', {
    attrs: {
      "options": _vm.tags,
      "placeholder": "Enter tag",
      "multiple": false
    },
    on: {
      "value": _vm.updateTag
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-right": "10px"
    }
  }, [_c('div', {
    staticClass: "input-label"
  }, [_vm._v("Article Published")]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('md-datepicker', {
    attrs: {
      "md-immediately": ""
    },
    model: {
      value: (_vm.filterByTimestamp),
      callback: function($$v) {
        _vm.filterByTimestamp = $$v
      },
      expression: "filterByTimestamp"
    }
  })], 1)]), _vm._v(" "), _c('div', [_c('button', {
    staticStyle: {
      "margin-top": "20px",
      "height": "30px"
    },
    on: {
      "click": function($event) {
        _vm.clearFilters();
      }
    }
  }, [_vm._v("CLEAR FILTERS")])]), _vm._v(" "), _c('div', {
    staticClass: "flex-1"
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "300px"
    }
  }, [_c('div', {
    staticClass: "input-label"
  }, [_vm._v("Search")]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchTerm),
      expression: "searchTerm"
    }],
    staticClass: "modal-input",
    attrs: {
      "placeholder": "Start typing to search..."
    },
    domProps: {
      "value": (_vm.searchTerm)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.searchTerm = $event.target.value
      }, _vm.searchForTerm]
    }
  })])])])]), _vm._v(" "), _c('md-table', [_c('md-table-row', [_c('md-table-head', [_vm._v("TITLE")]), _vm._v(" "), _c('md-table-head', [_vm._v("AUTHOR")]), _vm._v(" "), _c('md-table-head', [_vm._v("STATUS")]), _vm._v(" "), _c('md-table-head', [_vm._v("CATEGORY")]), _vm._v(" "), _c('md-table-head', [_vm._v("TAGS")]), _vm._v(" "), _c('md-table-head', [_vm._v("DATE")])], 1), _vm._v(" "), (_vm.searchResults.length == 0) ? _vm._l((_vm.posts), function(item, key) {
    return _c('md-table-row', {
      key: key,
      on: {
        "click": function($event) {
          _vm.editArticle(item)
        }
      }
    }, [_c('md-table-cell', {
      staticStyle: {
        "min-width": "30%"
      },
      domProps: {
        "innerHTML": _vm._s(item.title)
      }
    }), _vm._v(" "), _c('md-table-cell', {
      staticStyle: {
        "width": "200px"
      }
    }, [_vm._v(_vm._s(item.authorSlug))]), _vm._v(" "), _c('md-table-cell', {
      staticStyle: {
        "width": "100px"
      }
    }, [_vm._v(_vm._s(item.status))]), _vm._v(" "), _c('md-table-cell', {
      staticStyle: {
        "width": "200px"
      }
    }, [_vm._v(_vm._s(item.parentCategory) + _vm._s(item.subCategory ? " | " + item.subCategory : ""))]), _vm._v(" "), _c('md-table-cell', {
      staticClass: "tags",
      staticStyle: {
        "min-width": "30%"
      }
    }, _vm._l((item.tags), function(tag, tagkey) {
      return _c('span', {
        key: tagkey
      }, [_vm._v(_vm._s(tag) + " ")])
    })), _vm._v(" "), _c('md-table-cell', {
      staticStyle: {
        "width": "100px"
      }
    }, [_vm._v(_vm._s(_vm._f("moment")(_vm.$moment(item.timestamp * 1000), "hh:mm DD/MM/YYYY")))])], 1)
  }) : _vm._l((_vm.searchResults), function(item, key) {
    return _c('md-table-row', {
      key: key,
      on: {
        "click": function($event) {
          _vm.editArticle(item)
        }
      }
    }, [_c('md-table-cell', {
      staticStyle: {
        "min-width": "30%"
      },
      domProps: {
        "innerHTML": _vm._s(item.title)
      }
    }), _vm._v(" "), _c('md-table-cell', {
      staticStyle: {
        "width": "200px"
      }
    }, [_vm._v(_vm._s(item.author))]), _vm._v(" "), _c('md-table-cell', {
      staticStyle: {
        "width": "100px"
      }
    }, [_vm._v("publish")]), _vm._v(" "), _c('md-table-cell', {
      staticStyle: {
        "width": "200px"
      }
    }, [_vm._v(_vm._s(item.categories))]), _vm._v(" "), _c('md-table-cell', {
      staticClass: "tags",
      staticStyle: {
        "min-width": "30%"
      }
    }, _vm._l((item.tags.split(',')), function(tag, tagkey) {
      return _c('span', {
        key: tagkey
      }, [_vm._v(_vm._s(tag))])
    })), _vm._v(" "), _c('md-table-cell', {
      staticStyle: {
        "width": "100px"
      }
    }, [_vm._v(_vm._s(_vm._f("moment")(_vm.$moment(item.timestamp * 1000), "hh:mm DD/MM/YYYY")))])], 1)
  })], 2), _vm._v(" "), (_vm.posts.length == 20) ? _c('button', {
    staticStyle: {
      "margin": "5px auto",
      "display": "block",
      "width": "300px"
    },
    on: {
      "click": _vm.morePosts
    }
  }, [_vm._v("MORE ITEMS")]) : _vm._e()], 1) : _c('div', [_c('div', [_c('md-button', {
    staticClass: "md-icon-button md-primary",
    on: {
      "click": function($event) {
        _vm.articleToEditKey = false
      }
    }
  }, [_c('md-icon', [_vm._v("arrow_back_ios")])], 1)], 1), _vm._v(" "), _c('article-editor', {
    ref: "editor",
    on: {
      "not-found": function($event) {
        _vm.articleToEditKey = false
      }
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-55214aec"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/articleList.vue
// module id = 661
// module chunks = 1